import ViewBase from "../../../../framework/core/mvvm/view_base";

const {ccclass, property} = cc._decorator;
export enum ChatType {
    none=0,
    friendChat=1,
    friendList=2,
    worldChat=3,
    system=3,

}
@ccclass
export default class HornView extends ViewBase {

    @property(cc.Button)
    sendBtn:cc.Button = null;

    @property(cc.Button)
    closeBtn:cc.Button = null;

    @property(cc.EditBox)
    inputTxt:cc.EditBox = null;


   start () {
        
    }

    
   
    
  
    
    // update (dt) {}
}
